import axios from 'axios';

export function getLanguages() {
  return axios.get('/api/v2/languages');
}
